// extracted by mini-css-extract-plugin
export default {"header":"YR-z","isActive":"ZR-z"};